import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import img1 from "../../assets/service-web.jpg";
import img2 from "../../assets/service-seo.png";
import img3 from "../../assets/service-digital.png";
import img4 from "../../assets/logo-design-768x768.png";
import img5 from "../../assets/facebook-ads-1-768x768.png";
import img6 from "../../assets/software-dev-2-768x768.png";
import img7 from "../../assets/ecommerce-1-768x768.png";
import img8 from "../../assets/software-testing-768x768.png";
import img9 from "../../assets/web-maintenance-768x768.png";
import './servicesecton.css';
import { FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

function Mainservices() {

  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1200, // fade duration for all (ms)
      easing: "ease-in-out", // smooth effect
      once: true,
    });
  }, []);

    const handleClick = () => {
    navigate("/contactus");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  return (
    <div className="service-section">

      <div className="about-header" data-aos="fade-down" data-aos-duration="1000">
        <span className="about-breadcrumb">
          <a style={{ color: "#3a3a5e" }} href="/home">Home</a> <FaArrowRight /> <a href="/aboutus">Service</a>
        </span>

        <h1 className="about-heading">Services</h1>
        <p className="about-description">
          From logo design to website development and digital marketing,
          <br />we’ve got all your online needs covered.
        </p>
      </div>

      <div className='container '>
        <div className="service-cards" style={{ marginTop: "50px", marginBottom: "50px" }}>
          
          {/* Each card fades in slightly later with longer fade */}
          <div className="service-card" data-aos="fade-up" data-aos-delay="0" data-aos-duration="900">
            <img src={img1} alt="Web Development" />
            <h3>Web Development</h3>
            <p>We bring your vision online with seamless, responsive design tailored to your needs.</p>
            <button className='main-button' onClick={handleClick}>Learn More</button>
          </div>

          <div className="service-card" data-aos="fade-up" data-aos-delay="150" data-aos-duration="1000">
            <img src={img2} alt="SEO Optimization" />
            <h3>SEO Optimization</h3>
            <p>Enhance your online visibility and drive targeted traffic with our expert SEO services.</p>
            <button className='main-button' onClick={handleClick}>Learn More</button>
          </div>

          <div className="service-card" data-aos="fade-up" data-aos-delay="300" data-aos-duration="1100">
            <img src={img3} alt="Digital Marketing" />
            <h3>Digital Marketing</h3>
            <p>Grow your business and connect with your audience through our digital marketing services.</p>
            <button className='main-button' onClick={handleClick}>Learn More</button>
          </div>

          <div className="service-card" data-aos="fade-up" data-aos-delay="450" data-aos-duration="1200">
            <img src={img4} alt="Logo Designing" />
            <h3>Logo Designing</h3>
            <p>Custom logo design to make your brand stand out and leave a lasting impression.</p>
            <button className='main-button' onClick={handleClick}>Learn More</button>
          </div>

          <div className="service-card" data-aos="fade-up" data-aos-delay="600" data-aos-duration="1300">
            <img src={img5} alt="Facebook & Google Ads" />
            <h3>Facebook & Google Ads</h3>
            <p>Effective Facebook & Google Ads campaigns to boost your brand’s online visibility and drive results.</p>
            <button className='main-button' onClick={handleClick}>Learn More</button>
          </div>

          <div className="service-card" data-aos="fade-up" data-aos-delay="750" data-aos-duration="1400">
            <img src={img6} alt="Software Development" />
            <h3>Software Development</h3>
            <p>Custom development tailored to meet your business needs and enhance efficiency.</p>
            <button className='main-button' onClick={handleClick}>Learn More</button>
          </div>

          <div className="service-card" data-aos="fade-up" data-aos-delay="900" data-aos-duration="1500">
            <img src={img7} alt="E-Commerce Website" />
            <h3>E Commerce Website</h3>
            <p>E-commerce website service creates custom, user-friendly online stores that drive sales & enhance shopping experience.</p>
            <button className='main-button' onClick={handleClick}>Learn More</button>
          </div>

          <div className="service-card" data-aos="fade-up" data-aos-delay="1050" data-aos-duration="1600">
            <img src={img8} alt="Software Testing" />
            <h3>Software Testing</h3>
            <p>Software testing service ensures your applications are bug-free, reliable, and perform optimally across different environments.</p>
            <button className='main-button' onClick={handleClick}>Learn More</button>
          </div>

          <div className="service-card" data-aos="fade-up" data-aos-delay="1200" data-aos-duration="1700">
            <img src={img9} alt="Website Maintenance" />
            <h3>Website Maintenance</h3>
            <p>Web maintenance ensures site stays updated, secure, and performs smoothly with regular updates and bug fixes.</p>
            <button className='main-button' onClick={handleClick}>Learn More</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mainservices;
